import React from 'react';

const Textarea = ({ 
  label,
  error,
  helperText,
  className = '',
  fullWidth = false,
  rows = 4,
  ...props 
}) => {
  const textareaStyles = `
    px-4 py-3 rounded-2xl border bg-[var(--surface-card)]
    ${error ? 'border-error-500 focus:border-error-500 focus:ring-error-500/20' : 'border-neutral-200 focus:border-[var(--brand-green-deep)] focus:ring-[var(--brand-green-deep)]/20'}
    focus:ring-2 outline-none transition-gentle
    text-[var(--text-primary)] placeholder-[var(--text-muted)]
    disabled:bg-[var(--surface-soft-1)] disabled:cursor-not-allowed
    resize-none
  `;
  
  const widthClass = fullWidth ? 'w-full' : '';
  
  return (
    <div className={`${widthClass} ${className}`}>
      {label && (
        <label className="block font-medium mb-2" style={{ color: 'var(--text-primary)' }}>
          {label}
        </label>
      )}
      <textarea
        rows={rows}
        className={`${textareaStyles} ${widthClass}`}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-error-600">{error}</p>
      )}
      {helperText && !error && (
        <p className="mt-1 text-sm" style={{ color: 'var(--text-muted)' }}>{helperText}</p>
      )}
    </div>
  );
};

export default Textarea;
